import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useCallback, useContext, useState } from 'react';
import AnchorButton from '@/common/AnchorButton';
import AlertModal from '@/vdp/AlertModal';
import ModalContext from '~/context/vdp/ModalContext';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import useAlertStatus from '~/hooks/vdp/selectors/useAlertStatus';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';
import { CloseIcon } from './Alerts.styles';
import NotAvailableInCA from './NotAvailableInCA';
import OutOfMarket from './OutOfMarket';
import StopSaleRecall from './StopSaleRecall';
import TemporaryOutOfMarket from './TemporaryOutOfMarket';
import useIsTemporaryOutOfMarket from './useIsTemporaryOutOfMarket';
import VehicleSold from './VehicleSold';
import VehicleUnavailable from './VehicleUnavailable';

const Alerts = () => {
  const { setGeolocationModalOpen } = useContext(ModalContext);
  const {
    unavailable,
    stopSaleRecall,
    isSold,
    outOfMarket,
    showAlert,
    notAvailableInCA
  } = useAlertStatus();
  const { make, model } = useGetVehicleDetails();
  const [wasClosed, setClosed] = useState(false);
  const isTemporaryOutOfMarket = useIsTemporaryOutOfMarket();
  const isPermanentOutOfMarket = outOfMarket && !isTemporaryOutOfMarket;

  const shouldShowAlert = showAlert && !wasClosed;
  const mayClose = unavailable || isSold;

  const onClose = useCallback(() => {
    if (mayClose) setClosed(true);
  }, [mayClose]);

  useSubsequentEffect(() => {
    if (outOfMarket) window.scrollTo(0, 0);
  }, [outOfMarket]);

  return (
    <AlertModal isOpen={shouldShowAlert} maxWidth="721px" onClose={onClose}>
      {mayClose && <CloseIcon onClick={onClose} />}

      {unavailable && <VehicleUnavailable />}

      {stopSaleRecall && <StopSaleRecall make={make} model={model} />}

      {isSold && <VehicleSold />}

      {isPermanentOutOfMarket && <OutOfMarket />}

      {isTemporaryOutOfMarket && <TemporaryOutOfMarket />}

      {notAvailableInCA && <NotAvailableInCA />}

      {isPermanentOutOfMarket || notAvailableInCA ? (
        <div className="text-center">
          <AnchorButton
            data-analytics-id="Alert Modal - Search Locations"
            onClick={() => setGeolocationModalOpen(true)}
          >
            Change location
          </AnchorButton>
        </div>
      ) : null}
    </AlertModal>
  );
};

export default withErrorBoundary(Alerts);
